import { isThemeColor } from '../../utils';
import { ColorValue, HoneycombThemeBase } from '../types';
import { getColor } from './getColor';

export function resolveColorValue(theme: HoneycombThemeBase) {
    return (value: ColorValue): string => {
        if (value && isThemeColor(value)) {
            return getColor(theme)(value);
        }
        return typeof value === 'string' ? value : theme.palette.common.black;
    };
}
